import type { CSSProperties } from 'react';
import type { PaidJourneyTier } from '../../lib/subscription-journey/plan-presentation';
import { NovaFlatMark } from './NovaFlatMark.web';
import { SparkMark } from './SparkMark.web';

/**
 * The paywall's offer mark (`.premium-offer-mark`): Spark for Plus, the flat
 * Nova for Pro, in the brand colour. The design interpolates the two contours;
 * this cross-fades the two exact marks in 280ms (none under reduced motion,
 * see `.tabbio-sub-premium-mark` in global.css). Decorative: the heading
 * beside it names the plan.
 */
export function PremiumOfferMark({
  tier,
  size = 48,
  style,
}: {
  tier: PaidJourneyTier;
  size?: number;
  style?: CSSProperties;
}) {
  const pro = tier === 'pro';
  return (
    <span
      className="tabbio-sub-premium-mark"
      aria-hidden
      data-tier={tier}
      style={{ width: size, height: size, ...style }}
    >
      <span className="tabbio-sub-premium-mark-layer" style={{ opacity: pro ? 0 : 1 }}>
        <SparkMark size={size} />
      </span>
      <span className="tabbio-sub-premium-mark-layer" style={{ opacity: pro ? 1 : 0 }}>
        <NovaFlatMark size={size} color="currentColor" />
      </span>
    </span>
  );
}
